import { unifiedApi } from "@/common";
import { ref, computed } from "vue";
import { IPayPalApprovalResponse } from "@/common/api/unifiedPortal/interfaces";
import { defineStore } from "pinia";
import { pageStates } from "@/components/Buy/BuyEnums";
import { handleApiError } from "@/common/handleApiError";
import { AxiosError } from "axios";

export const usePayPalStore = defineStore("payPal", () => {
  const PayPalBillingAgreementResponse = ref<IPayPalApprovalResponse>();

  //store the shipping address to be used in Review order Page
  const payPalShippingAddress = computed(() => {
    return PayPalBillingAgreementResponse.value?.shippingAddress;
  });

  //Generate route to redirect to when paypal return success
  const getPayPalSuccessRoute = computed(() => {
    let path = "/";
    let queryParams = {};
    if (PayPalBillingAgreementResponse.value) {
      path = "buy";
      queryParams = Object.assign(
        {},
        {
          step: pageStates.reviewOrder,
          from: "Paypal",
          email: PayPalBillingAgreementResponse.value.email,
          paymentMethodId: PayPalBillingAgreementResponse.value.paymentMethodId,
        }
      );
    }
    return { path: path, query: queryParams };
  });

  async function setPayPalBillingAgreementResponse(ba_token: string) {
    try {
      //The response we get back contains the address of the user,their email and the paymentMethodId
      //send these back to the buy flow with that information
      PayPalBillingAgreementResponse.value = (await unifiedApi.payPalApprove(ba_token)).data;
    } catch (err) {
      handleApiError(err as AxiosError, false);
    }
  }

  return {
    setPayPalBillingAgreementResponse,
    getPayPalSuccessRoute,
    payPalShippingAddress,
  };
});
